import React from 'react';

import { IWidgetProps } from '@/shared/components/atoms/Widget/IWidget';
import { clsxm } from '@/shared/lib';

const Widget: React.FC<IWidgetProps> = ({
  number,
  title,
  icon,
  moreContent,
  numberStyle,
  className,
}) => {
  return (
    <div
      className={clsxm(
        'flex w-full flex-col justify-between gap-16 rounded-2xl bg-background-neutral-99 p-16',
        className
      )}
    >
      <div className='flex items-center gap-2'>
        {icon && (
          <span className='flex h-40 w-40 items-center justify-center rounded-full bg-primary-95 text-24 text-primary-default'>
            {icon}
          </span>
        )}
        <div className='text-base font-medium capitalize text-surface-10'>
          {title}
        </div>
      </div>
      <div className='flex items-center gap-2'>
        <div
          className={clsxm(
            'flex min-w-[40px] items-center justify-center !text-30 font-bold leading-none text-primary-default',
            numberStyle
          )}
        >
          {number}
        </div>
        {moreContent ?? ''}
      </div>
    </div>
  );
};
export { Widget };
